/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type FormSubmitPublicEntrypointComponent = EntryPointComponent<{}, {}, {}, {}>;

export const formSubmitPublicEntrypoint: EntryPoint<FormSubmitPublicEntrypointComponent, {}> =
	createEntryPoint({
		root: JSResourceForUserVisible<FormSubmitPublicEntrypointComponent>(
			/* webpackChunkName: "async-form-submit-public-entrypoint" */ './index.tsx',
			{
				entryFsSsrLiftImportToModule: true,
			},
		),
		getPreloadProps: () => ({}),
	});
